export default "__VITE_ASSET__BR4MJ25B__"